import type {Thread} from '@github-ui/diff-lines/conversation-types'
import {ProfileReference} from '@github-ui/profile-reference'
import {Link} from '@github-ui/react-router'
import {useGetHovercardAttributesForType} from '@github-ui/hovercards/use-get-hovercard-attributes-for-type'
import {ThreadGroupVariant, getVariantComment, ThreadGroupVariantLabels} from '../util/classify-thread'

export function ThreadTitle({thread, variant}: {thread?: Thread | null; variant: ThreadGroupVariant}) {
  const getHovercardAttributesForType = useGetHovercardAttributesForType()

  const author = thread ? getVariantComment(thread, variant)?.author : undefined
  const message = ThreadGroupVariantLabels[variant] || 'commented'

  if (!author) {
    // TODO: add ghost user support
    return <span>{message}</span>
  }

  const authorLogin = author.login

  return (
    <span>
      <Link
        to={`/${authorLogin}`}
        className="color-fg-default text-bold"
        {...getHovercardAttributesForType('user', {login: authorLogin})}
      >
        <ProfileReference login={authorLogin} isAgent={false} />
      </Link>
      {` ${message}`}
    </span>
  )
}
